import Vue from 'vue'
import Router from 'vue-router'
import AuthLayout from '../components/auth/AuthLayout'
import AppLayout from '../components/admin/AppLayout'
import Offres from '../components/offres.vue'
import Administrateur from '../components/Administrateur.vue'
import Adresse from '../components/Adresse.vue'
import ListeVehicule from '../components/listeVehicule.vue'
import UtiConducteur from '../components/utilisateur/conducteurs.vue'
import UtiPassagers from '../components/utilisateur/passagers.vue'
import Reservation from '../components/reservation.vue'
import Voyage from '../components/voyage.vue'
import Trajet from '../components/trajet.vue'
import SousListe from '../components/souscription/index.vue'
import SousActive from '../components/souscription/active.vue'
import SousExpire from '../components/souscription/expire.vue'
import ParamConfiguration from '../components/parametre/configuration.vue'
import ParamListe from '../components/parametre/liste.vue'
import Profile from '../components/profile'

Vue.use(Router)

const EmptyParentComponent = {
  template: '<router-view></router-view>',
}


export default new Router({
  mode: process.env.VUE_APP_ROUTER_MODE_HISTORY === 'true' ? 'history' : 'hash',
  routes: [
    {
      name: 'login',
      path: '/login',
      component: AuthLayout ,
    },
    {
      name: 'dashboard',
      path: '/',
      component: AppLayout,
      children:[
        {
          path: 'offres',
          name: 'offres',
          component: Offres
        },
        {
          path: 'profile',
          name: 'profile',
          component: Profile
        },
        {
          path: 'utilisateur',
          name: 'utilisateur',
          component: EmptyParentComponent,
          children:[
            {
              path:'conducteurs',
              name:'conducteurs',
              component: UtiConducteur
            },
            {
              path:'passagers',
              name:'passagers',
              component:UtiPassagers
            },
          ]
        },
        {
          path: 'trajet',
          name: 'trajet',
          component: Trajet
        },
        {
          path:'voyage',
          name:'voyage',
          component:Voyage
        },
        {
          path:'reservation',
          name:'reservation',
          component:Reservation
        },
        {
          path: 'souscription',
          name: 'souscription',
          component: EmptyParentComponent,
          children:[
            {
              path:'/',
              name:'index',
              component:SousListe
            },
            {
              path:'active',
              name:'active',
              component:SousActive
            },
            {
              path:'expire',
              name:'expire',
              component:SousExpire
            },
          ]
        },
        {
          path: 'parametre',
          name: 'parametre',
          component: EmptyParentComponent,
          children:[
            {
              path:'configuration',
              name:'configuration',
              component:ParamConfiguration
            },
            {
              path:'liste',
              name:'liste',
              component:ParamListe
            },
          ]
        },
        {
          path: 'administrateur',
          name: 'administrateur',
          component: Administrateur
        },
        {
          path: 'adresse',
          name: 'adresse',
          component: Adresse
        },
        {
          path: 'listeVehicule',
          name: 'listeVehicule',
          component: ListeVehicule
        }
      ]
    },
  ],
})
